module.exports = __webpack_public_path__ + "img/hero.28c79ded.png";